.main_content {
	.load_inventory {
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: flex-start;
		text-align: center;
		margin-top: 10px;
		gap: 25px;

		@media screen and (max-width: 750px) {
			flex-direction: row;
			align-items: flex-start;
		}

		.selects_container {
			display: flex;
			flex-direction: column;
			width: 100%;
			text-align: left;
			justify-content: center;
			align-items: center;
			margin-top: 10px;
		}

		.cards_section {
			display: flex;
			flex-wrap: wrap;
			width: 50%;
			justify-content: center;
			align-items: center;
			gap: 40px;

			@media screen and (max-width: 750px) {
				margin-top: 10px;
				flex-direction: column;
			}

			.card_container {
				display: flex;
				flex-direction: column;
				height: 200px;
				width: 200px;
				gap: 10px;

				.dowload_template_button {
					width: 100%;
					background-color: #ffff;
					border: 1px solid #7fb02f;
					border-radius: 5px;
					padding: 3px 0 3px 0;
					margin: 0 0 0 0;
					transition: transform 0.5s ease;

					span {
						margin-left: 5px;
					}
				}

				.dowload_template_button:hover {
					color: white;
					background-color: #7fb02f;
				}

				.card_div {
					display: flex;
					flex-direction: column;
					background-color: #ffff;
					width: 100%;
					height: 90%;
					border-radius: 5px;
					box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
					padding: 5px 0px 5px 0px;
					transition: transform 0.3s ease;
					cursor: pointer;

					&.disabled {
						opacity: 0.5;
					}

					.inventory_icon {
						height: 100%;
						width: 100%;
					}

					.label_row {
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-around;
						align-items: center;
						border-top: 1px solid #7fb02f;
						padding: 5px;
						margin: 0px;
					}
				}

				.card_div:hover {
					transform: scale(1.01);
				}
			}
		}
	}

	.unit_load {
		width: 100%;
		height: 100%;

		@media screen and (max-width: 750px) {
			margin-bottom: 3em;
			padding-right: 0em;
		}

		.header {
			width: 100%;
			display: flex;
			flex-direction: row;
			gap: 10px;

			.backIcon {
				cursor: pointer;
			}
		}

		.row_global_card {
			height: 100%;

			.col_base {
				margin-bottom: 10px;

				@media screen and (max-width: 950px) {
					max-height: initial;
					min-height: initial;
				}

				.header {
					height: 42%;
					animation: fade-in 1s;

					&.collapse {
						height: 0%;
					}

					.headerRight {
						border-left: 0.5px solid #d3d3d3;
						padding-left: 0px;
						padding-right: 0px;

						@media screen and (max-width: 950px) {
							border-left: 0px solid white;
						}
					}

					.divider {
						height: 2px;
						width: 100%;
						display: block;
						/* for use on default inline elements like span */
						margin: 9px 0;
						overflow: hidden;
						background-color: #e5e5e5;
					}

					.headerLeft {
						// border-right: 0.5px solid #d3d3d3;
						padding-left: 0px;
						padding-right: 0px;
					}

					@media screen and (max-width: 950px) {
						height: initial;
					}
				}

				.header_table {
					height: 5%;

					@media screen and (max-width: 750px) {
						display: none;
					}

					@media screen and (max-width: 950px) {
						height: initial;
					}
				}

				.body_table {
					height: 53%;
					overflow-y: auto;

					&::-webkit-scrollbar {
						width: 5px;
						height: 5px;
					}

					&::-webkit-scrollbar-track {
						background: #f1f1f1;
					}

					&::-webkit-scrollbar-thumb {
						background-color: #a8a8a8;
						border-radius: 15px;
					}
				}

				.divInput {
					// border: 1px solid #d3d3d3;
					padding: 0.5em;
					height: 100%;

					.inputForm {
						margin-bottom: 10px;

						.inputText {
							font-size: 16px;
							font-weight: 500;
							margin-bottom: 2px;
							color: #5e5e5e;
						}

						.inputValue {
							width: 100%;
							padding: 5px;
							border-radius: 5px;
							border: none;
							background-color: #f3f3f3;
						}
					}
				}

				.tableHead {
					margin-bottom: 0px;

					th {
						padding-top: 5px;
						padding-left: 2px;
						padding-right: 2px;
						font-size: 12px;
						font-weight: 500;
						border: none;
						color: #5e5e5e;
					}

					.productLabel {
						text-align: end;
						border: #d7373f !important;
						color: #2977ca;
					}
				}

				.tableBody {
					tr {
						td {
							&.singleValue {
								padding-top: 13px;
								width: 6%;
								text-align: center;
								font-weight: bold;
							}

							span {
								cursor: pointer;
							}
						}
					}
				}

				.tableDetail {
					th {
						padding-top: 5px;
						padding-left: 2px;
						padding-right: 2px;

						font-size: 12px;
						font-weight: 500;
						border: none;
						color: #5e5e5e;
					}

					.tableDetailHead {
						display: contents;

						.headTh {
							padding: 10px 5px;
							font-size: 11px;
						}
					}

					td {
						padding-top: 5px;
						padding-left: 2px;
						padding-right: 2px;
					}

					@media screen and (max-width: 750px) {
						overflow-x: auto;
						width: 60em;
					}
				}
			}

			.total {
				text-align: right;
				font-size: 17px;

				@media screen and (max-width: 950px) {
					font-size: 20px;
				}
			}

			.iconAdd {
				width: 1.5em;
				height: 1.5em;
				cursor: pointer;
			}

			.buttons {
				display: flex;
				justify-content: space-between;
				align-items: center;

				@media screen and (max-width: 950px) {
					margin-top: 1em;
					justify-content: space-around;
					flex-direction: column;
					align-items: center;
				}

				.beforeButton {
					width: 15%;
					display: flex;
					justify-content: center;
					padding: 0px 10px;

					@media screen and (max-width: 950px) {
						width: 100%;
					}

					div {
						width: 100%;
						text-align: center;
						font-size: 15px;
						background-color: #007bff;
						/* Change to your desired color */
						padding-top: 5px;
						padding-bottom: 7px;
						padding-left: 1.5em;
						padding-right: 1.5em;
						border-radius: 5px;
						font-weight: 400;
						color: white;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;

						@media screen and (max-width: 950px) {
							width: 100%;
							text-align: center;
							margin-bottom: 5px;
						}
					}
				}

				.rightButtons {
					display: flex;
					align-items: center;
					margin-left: auto;
					gap: 10px;

					.buttonClose {
						display: flex;
						justify-content: center;
						padding: 0px 10px;

						div {
							text-align: center;
							width: 100%;
							font-size: 15px;
							background-color: #d7373f;
							padding-top: 5px;
							padding-bottom: 7px;
							padding-left: 1.5em;
							padding-right: 1.5em;
							border-radius: 5px;
							font-weight: 400;
							color: white;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;

							@media screen and (max-width: 950px) {
								width: 100%;
								text-align: center;
								margin-bottom: 5px;
							}
						}
					}

					.buttonSave {
						display: flex;
						justify-content: center;
						padding: 0px 10px;

						div {
							width: 100%;
							text-align: center;
							font-size: 15px;
							background-color: #5a8217;
							padding-top: 5px;
							padding-bottom: 7px;
							padding-left: 1.5em;
							padding-right: 1.5em;
							border-radius: 5px;
							font-weight: 400;
							color: white;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;

							@media screen and (max-width: 950px) {
								width: 100%;
								text-align: center;
								margin-bottom: 5px;
							}
						}

						&.disabled {
							div {
								background-color: #7d8f5f;
							}
						}
					}
				}
			}
		}
	}
}

.customCancelBtn {
	background-color: #7d8f5f !important;
	color: white !important;
	border: none !important;
}

.customConfirmBtn {
	background-color: #dc3545 !important;
	color: white !important;
	border: none !important;
}
